<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord" />
  </div>
</template>

<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editRecord() {
      // 1. Set item to edit
      this.$store.dispatch('setGroup', this.params.data)
      // 2. Set pop up title
      this.$store.dispatch(
        'setGroupPopUpTitle',
        `Επεξεργασία όμαδας (${this.params.data.name})`
      )
      // 3. Display pop up
      this.$store.dispatch('toggleGroupPopUp', true)
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Επιβεβαίωση διαγραφής',
        text: `Πρόκειται να διαγράψετε την εγγραφή "${this.params.data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Διαγραφή',
      })
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      // this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store
        .dispatch('deleteGroup', this.params.data.id)
        .then(() => {
          this.showDeleteSuccess()
        })
        .catch((err) => {
          console.error(err)
        })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        position: 'top-right',
        title: 'Η εγγραφή διαγράφηκε',
        text: 'Η επιλεγμένη εγγραφή διαγράφηκε με επιτυχία',
      })
    },
  },
}
</script>
